// We're using the tabs menu, the default navigation from React Admin isn't needed
export const AppMenu = () => {
  return null;
};
